<div class="d-flex align-items-center p-2 pr-5">
    <div class="day-time-badge text-center px-4">
        <div class="m-auto circle-initials rounded-circle d-flex flex-column justify-content-center">
            <div class="text-uppercase">{{model.classDate | bcDate: 'ddd'}} </div>
            <div class="day-of-month font-weight-bold">{{model.classDate | bcDate: 'DD'}} </div>
            <div class="font-label-smaller">{{model.classDate | bcDate: 'MMM'}} </div>
        </div>
        <div class="font-label-smaller">
            {{model.classTimeInMinutesFrom | timeDisplay}} - {{model.classTimeInMinutesTo | timeDisplay}}
        </div>
    </div>

    <div class="d-flex flex-column text-truncate mr-auto class-description justify-content-between">
        <div class="text-truncate">{{model.classCategory}}</div>
        <div class="h5 text-uppercase text-truncate font-weight-bold">{{model.className}}</div>
        <div class="text-truncate">
            <div *ngIf="showStatus" class="d-inline mr-2">
                <span *ngIf="isClosed" class="badge badge-pill badge-success">{{'SubBoard.StatusClosed' | translate}}</span>
                <span *ngIf="isCanceled" class="badge badge-pill badge-danger">{{'SubBoard.StatusCanceled' | translate}}</span>
                <span *ngIf="isOpen" class="badge badge-pill badge-secondary">{{ 'SubBoard.StatusOpen' | translate }}</span>
                <span *ngIf="isOverdue" class="badge badge-pill badge-warning">{{ 'SubBoard.StatusOverdue' | translate }}</span>
            </div>
            <span>{{model.clubShortName}}</span>
            <span *ngIf="model.classLocation"> | </span>
            <span class="text-truncate">{{model.classLocation}}</span>
        </div>
    </div>

    <div class="d-flex flex-column justify-content-center provider-icon-container">
        <app-provider-avatar-photo [photoUrl]="model.instructorPhotoUrl" [firstName]="model.instructorFirstName"
            [lastName]="model.instructorLastName" [width]="80" [height]="80">
        </app-provider-avatar-photo>
        <div class="provider-name">{{model.instructorFirstName}} {{model.instructorLastName}}</div>
    </div>

    <div class="arrow-container">
        <span class="ic-arrow-sub"></span>
    </div>

    <div *ngIf="shouldShowSubstitute; else proposalCounter" class="pr-5">
        <div class="provider-icon-container">
            <app-provider-avatar-photo [photoUrl]="model.substitutePhotoUrl" [firstName]="model.substituteFirstName"
                [lastName]="model.substituteLastName" [width]="80" [height]="80">
            </app-provider-avatar-photo>
            <div class="provider-name">{{model.substituteFirstName}} {{model.substituteLastName}}</div>
        </div>
    </div>

    <ng-template #proposalCounter>
        <div class="text-center pr-5">
            <div><img src="assets/ic_oval_user.svg"></div>
            <div class="offers-count-label">
                <span *ngIf="model.offersCount == 0" class="text-greyed-out">{{'SubBoard.OffersCount0' | translate}}</span>
                <span *ngIf="model.offersCount == 1" class="font-weight-bold">{{'SubBoard.OffersCount1' | translate}}</span>
                <span *ngIf="model.offersCount > 1" class="font-weight-bold">
                    {{'SubBoard.OffersCountMore' | translate : {offersCount: model.offersCount} }}
                </span>
            </div>
        </div>
    </ng-template>
    
</div>
